import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Tabs module configurations
export const LISTING_COLUMNS = [
  {
    id: 'id',
    label: 'ID',
    width: '1%',
    align: 'center',
    dataKey: 'id',
    sortable: true,
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'thumbnailUrl',
    label: 'Image Preview',
    width: '5%',
    align: 'center',
    dataKey: 'thumbImage',
    sortable: false,
    type: CELL_DATA_TYPES.IMAGE,
  },
  {
    id: 'title',
    label: 'Name',
    width: '30%',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'channelName',
    label: 'Channel',
    width: '20%',
    align: 'left',
    dataKey: 'channelName',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '15%',
    align: 'center',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified Date',
    width: '15%',
    align: 'center',
    dataKey: 'modifiedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
  {
    action: ACTIONS.UPLOAD_ASSETS.value,
    label: ACTIONS.UPLOAD_ASSETS.label,
  },
  {
    action: ACTIONS.ASSIGN_COLLECTION_CATEGORIES.value,
    label: ACTIONS.ASSIGN_COLLECTION_CATEGORIES.label,
  },
];

export const VIEW_COLLECTION_COLUMNS = [
  {
    id: 'title',
    label: 'Name',
    dataKey: 'title',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'description',
    label: 'Description',
    dataKey: 'description',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'thumbnailUrl',
    label: 'Card Image URL',
    dataKey: 'thumbImage',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'heroImageUrl',
    label: 'Hero Image URL',
    dataKey: 'heroImage',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'backgroundImage',
    label: 'Background Image URL',
    dataKey: 'backgroundImage',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified Date',
    dataKey: 'modifiedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
